import script from "./EditPersonalInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPersonalInformation.vue?vue&type=script&setup=true&lang=js"

import "./EditPersonalInformation.vue?vue&type=style&index=0&id=4e132fe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e132fe1"]])

export default __exports__